import Modal from 'react-modal';

const ModalControl = ({
    txtMsg = 'Cargando...',
    active = false,
    closeModal = () => { }
}: IModalProps) => {

    return (
        <Modal className="modal" isOpen={active} ariaHideApp={false}>
            <div className="dialog-center-content-ca">
                <p className="text-center">{txtMsg}</p>
            </div>
        </Modal>
    )
}

export { ModalControl }